import { Component } from "@ecs/Component";
import { SpecificController } from "./SpecificController";
import type { GameObject } from "@ecs/GameObject";
import type { PlayerController } from "./PlayerController";

type ComponentCtor<T extends Component> =
    new (gameObject: GameObject) => T
export class ControllerSpawner extends Component {
    controller: SpecificController | undefined
    buildData: any = {}
    onBuildQueue: ((controller: SpecificController) => void)[] = []

    // controllerClass: ComponentCtor<SpecificController> | undefined
    // others build data are transferred to the controller on spawn


    setup(_data: any) {
        super.setup(_data)
        this.buildData = _data
    }
    setPlayerController(controller: PlayerController) {
        this.buildData.playerController = controller
    }
    addBuildQueueListener(callback: (controller: SpecificController) => void) {
        this.onBuildQueue.push(callback)
    }
    spawnController(): SpecificController {
        if (this.controller?.exist) {
            this.gameObject.removeComponent(this.controller)
        }
        //check if controller class is specified with constructor
        if (this.buildData.controllerClass === undefined) {
            throw new Error("No controller class specified in buildData")
        }
        else {
            this.controller = this.gameObject.addComponent(this.buildData.controllerClass as ComponentCtor<SpecificController>, this.buildData)
        }
        for (const callback of this.onBuildQueue) {
            callback(this.controller)
        }
        return this.controller

    }
    onDestroy(): void {
        super.onDestroy()
        if (this.controller) {
            this.gameObject.removeComponent(this.controller)
        }
    }

}